import React from 'react';
import SaveButton from '../../components/Buttons/SaveButton'


const view = ({ onTextChange, onSubmit, oldPassword, newPassword, ReTypeNewPassword }) => {
    return (
        <div className="lg:m-6">
            <form onSubmit={onSubmit} className="border lg:w-2/4 border-grey-100 shadow m-4 rounded bg-white">
                <div className="flex justify-between m-4 border-b border-grey-100">
                    <div className="text-gray-700 lg:text-lg font-semibold mt-1 mb-2">تغيير كلمة السـر</div>
                </div>
                <div className="px-4 py-1">
                    <label htmlFor="oldPassword" className="block text-grey-500 text-sm font-semibold">كلمة المرور الحالية</label>
                    <input type="password" placeholder="********" value={oldPassword} name="oldPassword" onChange={onTextChange} className="w-full block h-8 text-grey-700 mt-2 pr-2 bg-grey-050 rounded text-sm focus:outline-none focus:bg-white focus:border-grey-200 focus:outline-none focus:bg-white focus:border-grey-200 border border-grey-100 leading-tight"></input>
                </div>
                <div className="px-4 py-1">
                    <label htmlFor="newPassword" className="block text-grey-500 text-sm font-semibold">كلمة المرور الجديدة</label>
                    <input type="password" placeholder="********" value={newPassword} name="newPassword" onChange={onTextChange} className="w-full block h-8 text-grey-700 mt-2 pr-2 bg-grey-050 rounded text-sm focus:outline-none focus:bg-white focus:border-grey-200 focus:outline-none focus:bg-white focus:border-grey-200 border border-grey-100 leading-tight"></input>
                </div>
                <div className="px-4 py-1">
                    <label htmlFor="ReTypeNewPassword" className="block text-grey-500 text-sm font-semibold">تاكيد كلمة المرور الجديدة</label>
                    <input type="password" placeholder="********" value={ReTypeNewPassword} name="ReTypeNewPassword" onChange={onTextChange} className="w-full block h-8 text-grey-700 mt-2 pr-2 bg-grey-050 rounded text-sm focus:outline-none focus:bg-white focus:border-grey-200 focus:outline-none focus:bg-white focus:border-grey-200 border border-grey-100 leading-tight"></input>
                </div>
                <hr className="m-4"></hr>
                <div className="m-4 flex flex-row-reverse">
                    <SaveButton
                        text="حفظ"
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
};

export default view;